/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Value_Customer_TextInputs */



/**
* | output |
* | --- |
* | "Safe, efficient and professionally unbiased services that put the client first." |
*
* @param {About_Value_Customer_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_value_customer_text = /** @type {((inputs?: About_Value_Customer_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Value_Customer_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("提供安全、高效、专业公正的服务，客户至上。")
	return /** @type {LocalizedString} */ ("Safe, efficient and professionally unbiased services that put the client first.")
});